module.exports = __webpack_public_path__ + "static/img/dibu.d0f3763.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/dibu.jpg
// module id = qtTl
// module chunks = 5